

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";


const salesOrderList = atom({ key: 'sales_order_return_atom', default: { so_return_main:[]} });




export  const SetSalesOrderReturnAtom = () => useSetRecoilState(salesOrderList);
export  const GetSalesOrderReturnAtom = () => useRecoilValue(salesOrderList);






